/** Cross-cutting events so Command Center (outside floating UI) can trigger chat actions. */
export const TEAM_CHAT_OPEN_FLOATING = 'coremonit-team-chat-open-floating';

export function dispatchOpenTeamChatFloating(peerId: string): void {
  window.dispatchEvent(new CustomEvent(TEAM_CHAT_OPEN_FLOATING, { detail: { peerId } }));
}
